'use client'

import { Transition, TransitionChild } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

import { ModalBackdrop } from '@src/components/Modal/ModalBackdrop'
import { cn } from '@src/utils/tailwind'

export const GeoRedirectionModalContent = ({
  children,
  onClose,
  isOpen,
  title,
}: {
  children: React.ReactNode
  onClose: () => void
  isOpen: boolean
  title: string
}) => {
  return (
    <Transition show={isOpen} as="div" className="relative z-1000">
      <TransitionChild>
        <ModalBackdrop className="backdrop-blur-sm" />
      </TransitionChild>

      <div className="fixed inset-0 flex items-center overflow-y-auto p-2">
        <TransitionChild>
          <div
            className={cn(
              'relative mx-auto overflow-hidden rounded-3xl bg-white shadow-md transition-all',
              'w-full p-6 pb-14 lg:max-w-[638px] lg:p-16',
              'data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-150 data-enter:ease-out data-leave:duration-150 data-leave:ease-in data-closed:lg:translate-y-0 data-closed:lg:scale-95'
            )}
          >
            <div className="mb-4 flex items-center justify-between gap-1 text-bodi-black-text lg:mb-1">
              <h2 className="text-heading-display-3">{title}</h2>
              <button
                onClick={onClose}
                className={cn(
                  'flex items-center justify-center rounded-full p-1 transition-all hover:bg-gray-100'
                )}
              >
                <XMarkIcon className="size-6 stroke-[2px]" />
              </button>
            </div>

            {children}
          </div>
        </TransitionChild>
      </div>
    </Transition>
  )
}
